"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_ENDPOINT = {
    getUserDetails: '/user-company/backoffice/users/{{userUuid}}',
    getUserFromIdp: '/user-company/backoffice/users/{{userUuid}}/from-idp',
    putInvalidateUsersDrivingLicense: '/user-company/backoffice/users/{{userUuid}}/driving-licenses/invalidate',
};
